var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeactivedDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9 4.36364H16.4V1.09091C16.4 0.488417 15.9075 0 15.3 0H8.7C8.09249 0 7.6 0.488417 7.6 1.09091V4.36364H2.1C1.49249 4.36364 1 4.85205 1 5.45455C1 6.05704 1.49249 6.54545 2.1 6.54545H3.2V22.9091C3.2 23.5116 3.69249 24 4.3 24H19.7C20.3075 24 20.8 23.5116 20.8 22.9091V6.54545H21.9C22.5075 6.54545 23 6.05704 23 5.45455C23 4.85205 22.5075 4.36364 21.9 4.36364ZM9.80005 2.18164H14.2V4.36346H9.80005V2.18164ZM5.3999 21.8186H18.5999V6.5459H5.3999V21.8186Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 8.72754C11.3926 8.72754 10.9001 9.21596 10.9001 9.81845V18.5457C10.9001 19.1482 11.3926 19.6366 12.0001 19.6366C12.6077 19.6366 13.1001 19.1482 13.1001 18.5457V9.81845C13.1001 9.21596 12.6077 8.72754 12.0001 8.72754Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69985 9.81836C8.09234 9.81836 7.59985 10.3068 7.59985 10.9093V17.4547C7.59985 18.0572 8.09234 18.5456 8.69985 18.5456C9.30737 18.5456 9.79985 18.0572 9.79985 17.4547V10.9093C9.79985 10.3068 9.30737 9.81836 8.69985 9.81836Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 10.9093V17.4547C14.2 18.0572 14.6924 18.5456 15.3 18.5456C15.9075 18.5456 16.4 18.0572 16.4 17.4547V10.9093C16.4 10.3068 15.9075 9.81836 15.3 9.81836C14.6924 9.81836 14.2 10.3068 14.2 10.9093Z",
    fill: "#E0E0E0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeactivedDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deactivedDelete.75d4770a623c6733fbd90d87b1896d20.svg";